import './MarketingMessage.scss';

interface MarketingMessageProps {
  heading: string;
  icon: string;
  showContact?: boolean;
  children?: React.ReactNode;
}

export const MarketingMessage = ({
  heading,
  showContact,
  icon,
  children,
}: MarketingMessageProps) => {
  return (
    <div className={`marketing--message`}>
      <h3>{heading}</h3>

      <div className="icon-copy">
        <img src={icon} alt="" width="100" height="100" />
        <div className="marketing--body">{children}</div>
      </div>
      {showContact && (
        <a href="https://www.elexity.io/contact" target="_blank" rel="noreferrer">
          Contact Elexity
        </a>
      )}
    </div>
  );
};
